import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

// initializeAppの複数回実行を制御
if (!firebase.apps.length) {
  const firebaseConfig = {
    apiKey: "AIzaSyCJv9rgteA7J72JsDnxmJmlg7BDMIPgWIg",
    authDomain: "color-record-test.firebaseapp.com",
    databaseURL: "https://color-record-test.firebaseio.com",
    projectId: "color-record-test",
    storageBucket: "color-record-test.appspot.com",
    messagingSenderId: "1047522148283",
    appId: "1:1047522148283:web:2861562b5a158cec2cce9e",
  };
  firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();

export { firebase, db };
